import React from "react";
import { motion } from "framer-motion";
import { Palette, Cpu, Zap, MousePointerClick } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const PILLARS = [
  { icon: Palette, label: "Design" },
  { icon: Cpu, label: "Tecnologia" },
  { icon: Zap, label: "Automação" },
  { icon: MousePointerClick, label: "Experiência" },
];

const About = () => (
  <section id="sobre" data-testid="about-section" className="relative overflow-hidden py-24 lg:py-32">
    <div className="bg-grid absolute inset-0 opacity-40 [mask-image:radial-gradient(ellipse_at_right,black_20%,transparent_65%)]" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
      <div>
        <SectionHeading
          eyebrow="SOBRE A EDALIX"
          title={
            <>
              TECNOLOGIA QUE <span className="text-gradient">TRANSFORMA NEGÓCIOS.</span>
            </>
          }
        />
        <Reveal delay={0.25}>
          <p className="mt-7 text-base font-light leading-relaxed text-white/70 md:text-lg">
            A EDALIX nasceu com um objetivo simples: transformar ideias e
            necessidades empresariais em soluções digitais modernas, funcionais e
            personalizadas.
          </p>
        </Reveal>
        <Reveal delay={0.35}>
          <p className="mt-5 text-base font-light leading-relaxed text-white/70 md:text-lg">
            Cada projeto é pensado de acordo com a realidade do negócio, buscando
            unir design, tecnologia, automação e uma experiência simples para quem
            utiliza.
          </p>
        </Reveal>
        <Reveal delay={0.45}>
          <div className="mt-9 flex flex-wrap gap-3">
            {PILLARS.map((p) => (
              <span
                key={p.label}
                data-testid={`about-pillar-${p.label.toLowerCase()}`}
                className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-xs font-medium tracking-wide text-white/70"
              >
                <p.icon className="h-3.5 w-3.5 text-[#00E5FF]" />
                {p.label}
              </span>
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <div
          className="relative mx-auto aspect-square w-full max-w-md"
          role="img"
          aria-label="Composição visual do símbolo EDALIX com elementos tecnológicos"
        >
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-3/4 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-br from-[#00E5FF]/15 to-[#8A2BE2]/20 blur-[80px]" />
          <div className="absolute inset-0 rounded-full border border-white/10" />
          <div className="animate-spin-slow absolute inset-8 rounded-full border border-dashed border-[#00E5FF]/25" />
          <div className="absolute inset-16 rounded-full border border-[#8A2BE2]/25" />
          <motion.div
            className="absolute inset-8"
            animate={{ rotate: -360 }}
            transition={{ duration: 34, repeat: Infinity, ease: "linear" }}
          >
            <span className="absolute left-1/2 top-0 h-2 w-2 -translate-x-1/2 rounded-full bg-[#00E5FF] shadow-[0_0_14px_rgba(0,229,255,0.9)]" />
            <span className="absolute bottom-6 right-2 h-1.5 w-1.5 rounded-full bg-[#8A2BE2] shadow-[0_0_12px_rgba(138,43,226,0.9)]" />
          </motion.div>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="rounded-3xl bg-gradient-to-br from-[#00E5FF] to-[#8A2BE2] p-[2px] shadow-[0_0_70px_rgba(0,229,255,0.35)]">
              <div className="flex h-28 w-28 items-center justify-center rounded-[calc(1.5rem-2px)] bg-[#050508] sm:h-32 sm:w-32">
                <span className="text-gradient font-display text-6xl font-black sm:text-7xl">E</span>
              </div>
            </div>
          </div>
          <span className="glass absolute right-0 top-10 rounded-full px-4 py-2 text-[10px] font-semibold tracking-[0.3em] text-white/70">
            EDALIX
          </span>
          <span className="glass absolute bottom-12 left-0 rounded-full px-4 py-2 text-[10px] font-semibold tracking-[0.3em] text-white/70">
            TECNOLOGIA
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
